import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

import { AuthService } from '../../../core/services/auth.service';
import { ToastMessageService } from '../../../core/services/toast-message.service';
import { FormErrorsComponent } from '../../../shared/components/form-errors/form-errors.component';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ButtonModule,
    FormErrorsComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  isSubmitting = false;
  submitted = false;
  token: string | null = null;
  email: string | null = null;
  invalidLink = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastMessageService
  ) {}

  ngOnInit() {
    this.initForm();
    this.getQueryParams();
  }

  initForm() {
    this.resetPasswordForm = this.fb.group({
      email: [{value: '', disabled: true}],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required]]
    }, {
      validators: this.passwordMatchValidator
    });
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      form.get('confirmPassword')?.setErrors(null);
      return null;
    }
  }

  getQueryParams() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.email = params['email'];

      if (!this.token || !this.email) {
        this.invalidLink = true;
        return;
      }

      this.resetPasswordForm.patchValue({ email: this.email });
    });
  }

  onSubmit() {
    if (this.resetPasswordForm.invalid || !this.token || !this.email) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const resetData = {
      email: this.email,
      token: this.token,
      new_password: this.resetPasswordForm.value.password,
      new_password_confirmation: this.resetPasswordForm.value.confirmPassword
    };

    this.authService.resetPasswordWithToken(resetData).subscribe({
      next: (response: any) => {
        this.isSubmitting = false;
        this.submitted = true;
        this.toastService.toastOnSuccess('Success', response.message || 'Password has been reset successfully');
        
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 3000);
      },
      error: () => {
        this.isSubmitting = false;
      }
    });
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }
}
